import React from 'react';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

export const PlanningLabel = () => {
  return (
    <Text fontSize="h6" mt="56" mb="24" mx="8" color="neutral.500">
      Planning data may not be up to date. Please contact your advisor with any questions and/or to
      update your data.
    </Text>
  );
};
